export const actionTypes = {
  CREATE_SEARCH_HISTORY_ITEM: 'CREATE_SEARCH_HISTORY_ITEM',
  GET_SEARCH_HISTORY: 'GET_SEARCH_HISTORY',
  CLEAR_SEARCH_HISTORY: 'CLEAR_SEARCH_HISTORY',
  PERFORM_SEARCH: 'PERFORM_SEARCH',
  START_TYPING: 'START_TYPING',
}
export const SEARCH_DEBOUNCE_WAIT = 200
export const BRANDS_COUNT = 6
